"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Option = _lib.Select.Option;
var children = [];
function ArcTagSelect(props) {
  var placeholder = props.placeholder,
    defaultValue = props.defaultValue,
    handleChange = props.handleChange;
  for (var i = 0; i < children.length; i++) {
    children.push( /*#__PURE__*/_react["default"].createElement(Option, {
      key: i.toString(children.length) + i
    }, i.toString(children.length) + i));
  }
  return /*#__PURE__*/_react["default"].createElement(_lib.Select, {
    mode: "tags",
    style: {
      width: '100%'
    },
    placeholder: placeholder,
    defaultValue: defaultValue,
    onChange: handleChange
  }, children);
}
var _default = ArcTagSelect;
exports["default"] = _default;